(function metadataControllerDefinition() {
    'use strict';

    angular.module('Metadata')
        .controller('MetadataFindController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminMetadataService', 'authExtend',
            function metadataController($scope, config, $state, $translate, $stateParams, errors, adminMetadataService, authExtend) {
                $scope.find =
                    {
                        Name: '',
                        Label: '',
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName(),
                        showNoData:false
                };

                $scope.items = [];
                $scope.hideAddBtn = !authExtend.isInRole('METADATA WRITE');

                $scope.findAction = function () {
                    $scope.items = [];
                    $scope.find.showNoData = false;

                    $scope.setRequestFilters();

                    return adminMetadataService.get($scope.find.Name, $scope.find.Label, $scope.find.organizationalUnitId).then(function getOk(result) {
                        $scope.items = result;
                        if ($scope.items.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) {
                        errors.showError(error);
                    });

                };

                $scope.modify = function(metadata) {
                    $state.go('metadata-modify', { id: metadata.id });
                };

                $scope.view = function (metadata) {
                    $state.go('metadata-detail', { id: metadata.id });
                };

                $scope.add = function () {
                    $state.go('metadata-add');
                };

                $scope.setRequestFilters = function () {

                    if ($stateParams.systemName != '') {
                        $scope.find.Name = $stateParams.systemName;
                        $stateParams.systemName = '';
                    }
                }

                $scope.load = function () {
                    $scope.findAction();
                }

                $scope.load();
            }
        ]);
})();